export default "/images/vendor/flag-icons/flags/1x1/mc.svg?21f385d1c90452e35d21436a60b29c07";